import React from "react";
import { Outlet } from "react-router-dom";

const MonitorOrder = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default MonitorOrder;
